import * as Sentry from '@sentry/react';
import { api } from 'src/common/utils/api';
import { useFlags } from 'src/feature-flags/FlagsHook';
import { notifyAndLogError } from 'src/UI/common/ui-helpers';
import { useAppContainerContext } from '../AppContainerContext';
import { StoredMessage } from '../chat/types';
import { useSiesta } from '../SiestaProvider';

export function useOpenConversation() {
  const { loadHistory, resumeActiveTurn } = useSiesta();
  const { setConversationId, setSiestaMode } = useAppContainerContext();
  const { flagEnabledSiestaChats, flagEnabledSiestaAsyncGeneration } = useFlags();

  return (id: string) => {
    void (async () => {
      try {
        const { data } = await api.get<{ messages: StoredMessage[]; activeTurnId: string | null }>(
          `conversations/${id}`,
        );
        setConversationId(id);
        loadHistory(data.messages);
        setSiestaMode('chat');
        if (flagEnabledSiestaChats && flagEnabledSiestaAsyncGeneration) {
          if (data.activeTurnId) {
            // Still generating: the resumed stream marks it read when it finishes.
            resumeActiveTurn(id, data.activeTurnId);
          } else {
            api.put(`conversations/${id}/read`).catch(error => Sentry.captureException(error));
          }
        }
      } catch (error) {
        notifyAndLogError(
          'Could not open chat',
          'The chat could not be opened. Please try again.',
          error,
        );
      }
    })();
  };
}
